import "./PawsportModal.scss";

import HeartGardenStamp from "../../assets/graphics/passport/HeartGarden.png";
import HearingRoomStamp from "../../assets/graphics/passport/HearingRoom.png";
import LakeBearbineStamp from "../../assets/graphics/passport/LakeBearbine.png";
import ParliamentHillStamp from "../../assets/graphics/passport/ParliamentHill.png";
import OpenPawsportEn from "../../assets/graphics/passport/OpenPawsport_en.png";
import OpenPawsportFr from "../../assets/graphics/passport/OpenPawsport_fr.png";

import i18n from "i18n/config";

interface PawsportModalProps {
  onClose?: () => void;
  quizCompletions?: { [key: string]: boolean };
}

const PawsportModal = ({
  onClose,
  quizCompletions = {},
}: PawsportModalProps) => {
  const lang = i18n.language;
  const pawsportBackground = lang === "fr" ? OpenPawsportFr : OpenPawsportEn;
  return (
    <div className="pawsport-modal">
      <div
        style={{
          backgroundImage: `url(${pawsportBackground})`,
        }}
        className="pawsport-modal__content"
      >
        {onClose && (
          <button
            className="pawsport-modal__close"
            onClick={onClose}
            aria-label="Close"
          >
            ×
          </button>
        )}
        <div className="pawsport-modal__stamps">
          {quizCompletions["LakeBearbine"] ? (
            <img src={LakeBearbineStamp} alt="Lake Bearbine" />
          ) : (
            <div />
          )}
          {quizCompletions["HearingRoom"] ? (
            <img src={HearingRoomStamp} alt="Hearing Room" />
          ) : (
            <div />
          )}
          {quizCompletions["HeartGarden"] ? (
            <img src={HeartGardenStamp} alt="Heart Garden" />
          ) : (
            <div />
          )}
          {quizCompletions["ParliamentHill"] ? (
            <img src={ParliamentHillStamp} alt="Parliament Hill" />
          ) : (
            <div />
          )}
        </div>
      </div>
    </div>
  );
};

export default PawsportModal;
